import { module } from 'angular';

import { default as spinnerDirectiveName, SpinnerDirectiveAjs } from './spinner.directive.ajs';

export default module('contact.commons.toolbox.spinner', []).directive(spinnerDirectiveName, SpinnerDirectiveAjs).name;
